import { Navigate, Route, Routes } from 'react-router-dom';
import HRDashboardPage from './HRDashboardPage';
import DirectoryPage from './DirectoryPage';
import OrganizationPage from './OrganizationPage';
import LeavePage from './LeavePage';

export default function HRPortalRoutes() {
  return (
    <Routes>
      <Route index element={<HRDashboardPage />} />
      <Route path="directory" element={<DirectoryPage />} />
      <Route path="organization" element={<OrganizationPage />} />
      <Route path="leave" element={<LeavePage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
